"use strict";

(function () {

	angular.module('app.userlogin').
		controller('forgotPassController', forgotPassController);

	forgotPassController.$inject = ['$http', '$scope', '$location', 'localizationService', '$timeout', 'utilFunctions'];

	function forgotPassController($http, $scope, $location, localizationService, $timeout, utilFunctions) {
		var vm = this;
		vm.email = "";
		vm.showMessage = false;
		vm.resultMsg = "";
		vm.resultClass = '';
		vm.hideMsg = true;
		vm.emailSent = true;
		vm.localStrings = [];
		vm.disableButton = false;
		vm.showPage = false;

		var init = function () {
			localizationService.getTaskBrowserLocalStrings(109).then(function (taskStrings) {
				console.log("taskStrings", taskStrings);
				vm.localStrings = angular.copy(taskStrings);
				vm.showPage = true;
			});
		};

		vm.getLocalString = function (stringNum) {
			var idx = utilFunctions.getIndexByProperty(vm.localStrings, "StringNum", stringNum);
			return (idx != -1) ? vm.localStrings[idx].LocalText : "String Not Found";
		}

		vm.reset = function () {
			vm.hideMsg = true;
			vm.emailSent = true;
			vm.disableButton = true;
			$http.get("reset/ForgotPass/SendPassReset?email=" + encodeURIComponent(vm.email) + "&hostName=" + window.location.host)
				.success(function (data) {
					if (data === 1) {
						vm.resultClass = 'bg-success text-success';
						vm.stringNo = 4532;
						vm.hideMsg = false;
						vm.emailSent = true;
						$timeout(function () {
							$location.path('/login');
						}, 6000);
					}
					else {
						vm.stringNo = 4534;
						vm.resultClass = 'bg-danger text-danger';
						vm.hideMsg = false;
						vm.emailSent = false;
					}
				});

			return;
		};

		init();
	}
}());